import {SensorChartRenderer} from '../sensor-chart/SensorChartRenderer';
import {OscilloRenderContext} from './OscilloRenderContext';
import {IRenderer} from '../../Renderer';
import {Bounds} from '../../Core';
import {IChartOptions} from '../../ChartOptions';
import {MarkerType} from '../../Marker';

	export class OscilloRenderer extends SensorChartRenderer implements IRenderer<OscilloRenderContext> {

		private _prevStartTime = 0;
		private _prevPlotBounds = new Bounds();
		private _prevYScale = 0;

		public render(context: OscilloRenderContext, options: IChartOptions) {
			super.render(context, options);
		}

		public renderGrid(context: OscilloRenderContext, options: IChartOptions) {
			var startTime = context.axesConfiguration.xAxes[0].minimum;
			var yScale = context.axesConfiguration.yAxes[0].scaleFactor;
			var plotBounds = context.getComponentLayout().plot;
			if(this._prevStartTime !== startTime
				|| this._prevPlotBounds.width !== plotBounds.width
				|| this._prevPlotBounds.height !== plotBounds.height
				|| yScale != this._prevYScale) {
				super.renderGrid(context, options);
			}
			this._prevStartTime = startTime;
			this._prevPlotBounds = new Bounds(plotBounds.width, plotBounds.height);
		}

		public renderSeries(context: OscilloRenderContext, options: IChartOptions) {

			var ctx = context.getContext('series', 2);

			var layout = context.getComponentLayout();
			var width = layout.plot.width;
			var height = layout.plot.height;
			var top = layout.plot.top;
			var left = layout.plot.left;
			var right = left + width;
			var bottom = top + height;

			var xAxis = context.axesConfiguration.xAxes[0];
			var yAxis = context.axesConfiguration.yAxes[0];

			var clearBuffer = Math.min(context.gridConfiguration.vertical.majorStep, 40);
			var clearWidth = (this._prevYScale !=yAxis.scaleFactor)
					? ctx.canvas.width
					: (context.clearPosition - xAxis.minimum) * xAxis.scaleFactor + clearBuffer;
			ctx.clearRect(0, 0, clearWidth, ctx.canvas.height);

			context.seriesConfiguration.series.forEach(series => {

				ctx.strokeStyle = series.color || options.seriesColor;

				//previous values
				var index = 0; //save last index of history item
				if(this._prevYScale !=yAxis.scaleFactor) {
					ctx.beginPath();
					var prevCoords = undefined;
					for(var i=index; i<series.values.length; i++) {
						var item = series.values[i];
						var xValue = series.valueProvider.getX(item);
						var yValue = series.valueProvider.getY(item);

						if(item === null || item === undefined || yValue === null || yValue === undefined) {
							// add gaps on null values
							ctx.stroke();
							ctx.beginPath();
							prevCoords = null;
						}

						//previous values
						if(xValue < context.historyStart ) {
							continue;
						}
						else if(xValue >= xAxis.minimum) {
							break;
						}
						else {
							var coords = {
								x: left + ( xValue + xAxis.maximum - 2*xAxis.minimum)  * xAxis.scaleFactor,
								y: bottom - (yValue - yAxis.minimum) * yAxis.scaleFactor
							};
							(prevCoords) ?
								ctx.moveTo(prevCoords.x, prevCoords.y) :
								ctx.moveTo(coords.x, coords.y);
							ctx.lineTo(coords.x, coords.y);
							prevCoords = coords;
						}
						index=i;
					}
					ctx.stroke();
				}

				//current values
				ctx.beginPath();
				var prevCoords = undefined;
				for(var i=index; i<series.values.length; i++) {

					var item = series.values[i];
					var xValue = series.valueProvider.getX(item);
					var yValue = series.valueProvider.getY(item);

					if(item === null || item === undefined || yValue === null || yValue === undefined) {
						// add gaps on null values
						ctx.stroke();
						ctx.beginPath();
						prevCoords = null;
					}
					if(xValue < xAxis.minimum) {
						continue;
					}
					else if (xValue >= context.clearPosition) {
						break;
					}
					else {
						var coords = {
							x: left + ( xValue - xAxis.minimum)  * xAxis.scaleFactor,
							y: bottom - (yValue - yAxis.minimum) * yAxis.scaleFactor
						};
						(prevCoords) ?
							ctx.moveTo(prevCoords.x, prevCoords.y) :
							ctx.moveTo(coords.x, coords.y);
						ctx.lineTo(coords.x, coords.y);
						prevCoords = coords;
					}
				}
				ctx.stroke();
			});

			this._prevYScale = yAxis.scaleFactor;
		}

		public renderMarkers(context: OscilloRenderContext, options: IChartOptions){

			var ctx = context.getContext('markers-front', 3);
			ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
			var ctxBack = context.getContext('markers-back', 1);
			ctxBack.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

			if(!context.markers || context.markers.length == 0){
				return;
			}

			var layout = context.getComponentLayout();
			var width = layout.plot.width;
			var height = layout.plot.height;
			var top = layout.plot.top;
			var left = layout.plot.left;
			var right = left + width;
			var bottom = top + height;

			var xAxis = context.axesConfiguration.xAxes[0];
			var yAxis = context.axesConfiguration.yAxes[0];

			//draw horizontal timeline
			ctx.fillStyle = options.timeline.color;
			ctx.fillRect(left, bottom - options.timeline.strokeWidth, width, options.timeline.strokeWidth);

			//draw markers
			var radius = 5;
			for(var i=0; i<context.markers.length; i++){
				var marker = context.markers[i];
				var xValue = marker.timestamp;

				// context.historyStart < xAxis.minimum <= context.clearPosition < xAxis.maximum
				var coords = {x: left, y:bottom};
				//previous values
				if(xValue < context.historyStart) {
					continue;
				}
				else if(context.historyStart < xValue &&
							xValue < xAxis.minimum) {
					coords = {
						x: left + ( xValue + xAxis.maximum - 2*xAxis.minimum)  * xAxis.scaleFactor,
						y: bottom
					};
				}
				else if(xAxis.minimum <= xValue &&
							xValue < context.clearPosition) {
					coords = {
						x: left + ( xValue - xAxis.minimum)  * xAxis.scaleFactor,
						y: bottom
					};
				}
				else {
					continue;
				}

				if(marker.type == MarkerType.HIGHLIGHT){
					var coords2 = {
						x: coords.x,
						y: top,
						width: (marker.value || 1) * xAxis.scaleFactor,
						height: height
					};
					//no transparency not to show overlapped markers
					// ctxBack.globalAlpha = 0.5;
					ctxBack.fillStyle = marker.color;
					ctxBack.fillRect(coords2.x, coords2.y, coords2.width, coords2.height);
					ctxBack.globalAlpha = 1;
				}
				else //if(marker.type == dataset.MarkerType.CIRCLE){
				{
					coords.y = (marker.value !== undefined)
								? bottom - (marker.value  - yAxis.minimum) * yAxis.scaleFactor
								: bottom;
					ctx.beginPath();
					ctx.arc(coords.x, coords.y, radius, 0, 2 * Math.PI, false);
					ctx.fillStyle = marker.color;
					ctx.fill();
					ctx.closePath();
				}
			};
		}

	}
